import clsx from "clsx";
import { useMemo } from "react";

import Avatar from "~/components/Avatar";
import Tooltip from "~/components/Tooltip";
import type { StaffingClosingStatusesByMonth } from "~/modules/billing/api/unprocessedInvoicesTypes.ts";
import { getAggregatedStaffingClosingStatuses } from "~/modules/billing/utils/billingUtils.ts";
import type { User, UserWithConfidentialInformation } from "~/modules/user/api/user/userTypes.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";

type Props = {
	allUsersData: User[] | UserWithConfidentialInformation[];
	staffingsClosingStatuses: StaffingClosingStatusesByMonth[];
};

const UsersMonthlyClosingStatus = ({ allUsersData, staffingsClosingStatuses }: Props) => {
	return useMemo(() => {
		if (staffingsClosingStatuses && allUsersData) {
			const aggregatedStaffingClosingStatuses = getAggregatedStaffingClosingStatuses(staffingsClosingStatuses);
			(staffingsClosingStatuses);
			const enrichedStatusData = aggregatedStaffingClosingStatuses.map(staffedUser => {
				const user = allUsersData.find((user) => user.id === staffedUser.userId);
				return {
					avatarImage: user?.avatarImage,
					firstName: user?.firstName,
					fullName: user?.fullName,
					lastName: user?.lastName,
					...staffedUser,
				};
			}).sort(byObjectProperty("fullName"));

			return enrichedStatusData.map((statusData) => {
				return <div className={clsx("rounded-full border-4 ", statusData.hasClosed ? "border-success-500" : "border-danger-500")}
							key={"staffedUser" + statusData.userId}>
					<Tooltip text={statusData.fullName || ""}>
						<Avatar image={statusData.avatarImage}
								firstName={statusData.firstName}
								lastName={statusData.lastName}
								width="w-10"
								height="h-10"
						/>
					</Tooltip>
				</div>;
			});
		}
		return null;
	}, [allUsersData, staffingsClosingStatuses]);
};

export default UsersMonthlyClosingStatus;